const { gql } = require('graphql-tag');

const ReferenceFragment = require('./referenceFragment').fragment;

module.exports = {
  fragment: gql`
    ${ReferenceFragment}

    fragment InitiatorFragment on Initiator {
      isPlatformClient
      externalUserId
      anonymousId
      clientId
      customerRef {
        ...ReferenceFragment
      }
      userRef {
        ...ReferenceFragment
      }
    }
  `,
};
